import { useMemo } from 'react';
import dict from '../i18n/landingCommon.json';
import { createT } from '../i18n/createT';

/**
 * Traducteur du CHROME commun aux 16 landings thématiques : tout ce que
 * `LandingThemePage` affiche à l'identique quel que soit le thème.
 *
 * Le contenu PROPRE à chaque thème ne passe pas par ici — il vit dans
 * `content/landings*.js` et se résout par `landingTheme(slug, lang)`.
 */
export function useLandingT(language) {
  return useMemo(() => createT(dict, language), [language]);
}

export default useLandingT;
